var ezdia;
(function (ezdia) {
    var NAME = 'popupList';
    var TYPE = 'popupList';
    var DATA_TYPE = "ez." + TYPE;
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var DEFAULT = {
        animation: true,
        container: 'body',
        html: true,
        placement: 'auto',
        rowSelector: '[data-type="row"]',
        itemTemplate: ezdia.templates.popupList.itemTemplate,
        popoverList: ezdia.templates.popupList.popoverList,
        buttonLabel: 'Done',
        trigger: 'click',
        content: '',
        buttons: false,
        search: true
    };
    var PopupList = /** @class */ (function () {
        function PopupList(elem, options) {
            this.elem = elem;
            this.init(options);
        }
        Object.defineProperty(PopupList.prototype, "Defaults", {
            get: function () {
                return DEFAULT;
            },
            enumerable: false,
            configurable: true
        });
        PopupList.prototype.destroy = function () {
            this.$elem.removeData("ez." + TYPE);
            $('[data-container="buttons"] button').each(function each() {
                $(this).off("." + TYPE);
            });
            $(document).off("keyup." + TYPE + this.elemId);
            this.$elem.popover('destroy');
        };
        PopupList.prototype.getOptions = function (options) {
            return __assign(__assign(__assign({}, DEFAULT), this.$elem.data()), options);
        };
        PopupList.prototype.init = function (options) {
            this.elemId = this.elem.id;
            this.$elem = $(this.elem);
            this.options = this.getOptions(options);
            this.popoverId = "popover_" + this.elemId;
            this.searchId = "poverSearch_" + this.elemId;
            this.buttons = this.options.buttons && this.createPopverButtons();
            // This method only used for backend support.
            this.itemTemplate();
            this.createPopover();
        };
        PopupList.prototype.itemTemplate = function () {
            if (this.options.template && typeof this.options.template === 'string') {
                this.options.popoverList = $.ezdia.template.get(this.options.template);
            }
            if (typeof this.options.itemTemplate === 'string') {
                this.options.itemTemplate = $.ezdia.template.get(this.options.itemTemplate);
            }
        };
        PopupList.prototype.createPopover = function () {
            var self = this;
            var options = this.options;
            var popoverContent = {
                popoverId: this.popoverId,
                id: this.searchId,
                buttons: this.buttons,
                btnLabel: options.buttonLabel
            };
            // eslint-disable-next-line no-unused-expressions
            options.search && (options.content.searchId = this.searchId);
            this.$elem
                .popover({
                animation: options.animation,
                container: options.container,
                template: this.options.popoverList(popoverContent),
                html: options.html,
                content: this.options.itemTemplate(options.content),
                placement: options.placement,
                trigger: options.trigger
            })
                .popover('show')
                .on('shown.bs.popover', function () {
                $(document).on("keyup." + TYPE + self.elemId, function (e) {
                    if (e.which === 27) {
                        self.destroy();
                    }
                });
            });
            this.bindEvents();
            this.checkPostion();
            // eslint-disable-next-line no-unused-expressions
            options.search && $("#" + this.searchId).filterSearch();
        };
        PopupList.prototype.createPopverButtons = function () {
            var arr = [];
            $.each(this.options.buttons, function (name, fn) {
                var obj = {};
                obj.btns = {
                    label: name,
                    fn: fn
                };
                arr.push(obj);
            });
            return arr;
        };
        PopupList.prototype.bindEvents = function () {
            var self = this;
            $("#" + this.popoverId)
                .find('[data-container="buttons"] button')
                .each(function each(i) {
                var fn = self.buttons[i] && self.buttons[i].btns.fn;
                if (!self.buttons[i] && $(this).data('btn') === 'done') {
                    $(this).on("click." + TYPE, $.proxy(self.destroy, self));
                }
                else {
                    $(this).on("click." + TYPE, fn);
                }
            });
        };
        PopupList.prototype.checkPostion = function () {
            var popup = $("#" + this.popoverId);
            var left = popup.offset().left;
            var width = popup.outerWidth();
            var screenWidth = $(window).width();
            var outofScreen = left + width - screenWidth;
            if (outofScreen > 0) {
                popup.css('left', left - outofScreen);
                popup.find('.arrow').css({
                    'margin-left': outofScreen - 11
                });
            }
        };
        return PopupList;
    }());
    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */
    var publicMethods = {
        destroy: PopupList.prototype.destroy
    };
    function jQueryInterface(option) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (option === 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        if (typeof option === 'string' && option !== 'destroy') {
            return invokePublicMethod.call(this, option, args);
        }
        return createNewInstance.call(this, option);
    }
    function invokePublicMethod(methodName, args) {
        if (publicMethods[methodName]) {
            var inputObject = retrieveObjectFromElement(this);
            if (!inputObject) {
                return;
            }
            var result = publicMethods[methodName].apply(inputObject, args);
            if (typeof result === 'undefined') {
                // eslint-disable-next-line consistent-return
                return $(this);
            }
            // eslint-disable-next-line consistent-return
            return result;
        }
        throw new Error("method '" + methodName + "()' does not exist for input list.");
    }
    // eslint-disable-next-line consistent-return
    function retrieveObjectFromElement(element) {
        var inputObject = $(element).data(DATA_TYPE);
        if (inputObject && inputObject instanceof PopupList) {
            return inputObject;
        }
    }
    function createNewInstance(option) {
        var $this = $(this);
        $this.each(function each() {
            var self = $(this);
            var data = self.data(DATA_TYPE);
            var options = typeof option === 'object' && option;
            if (!data) {
                self.data(DATA_TYPE, (data = new PopupList(this, options)));
            }
            if (typeof option === 'string') {
                data[option]();
            }
        });
        return $this;
    }
    $.fn[NAME] = jQueryInterface;
    $.fn[NAME].Constructor = PopupList;
    $.fn[NAME].noConflict = function noConflict() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return jQueryInterface;
    };
})(ezdia || (ezdia = {}));
